import { FETCH_SITE_DATA } from "../actions/types";

const INITIAL_STATE = {
  currentLoad: null,
  setpoint: null,
  genericPmax: null,
  pMaxOffPeak: null,
  pMaxOnPeak: null,
  pMaxLoad: null,
  pMaxLoadWithoutBess: null,
  bessInstantPower: null,
  bessStatus: null,
  soc: null,
  soh: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_SITE_DATA:
      return { ...state, ...payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/site_data_reducer.js